export const getAvatarUrl = (photoUrl, prefix) => {
  if (!photoUrl) return ''
  const index = photoUrl.lastIndexOf('/')
  const before = photoUrl.slice(0, index)
  const after = photoUrl.slice(index + 1)
  return `${before}/${prefix}${after}`
}
